import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Coins } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

/** Header pill (Pro students): teacher-feedback credit balance — tap to open the wallet. */
export default function CreditsPill() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [w, setW] = useState(null);
  const isPro = user?.subscription_status && user.subscription_status !== 'free';
  useEffect(() => {
    if (!isPro) { setW(null); return undefined; }
    let alive = true;
    api.get('/api/feedback-credits/me').then((r) => { if (alive) setW(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, [isPro, pathname]);
  if (!w || !w.is_pro || !w.enabled) return null;
  const open = (w.requests || []).filter((r) => r.status === 'pending' || r.status === 'in_review').length;
  return (
    <Link to="/feedback-credits" title={`${w.balance} teacher-feedback credits${open ? ` · ${open} review${open === 1 ? '' : 's'} in progress` : ''} — open your wallet`}
      className="inline-flex items-center gap-1.5 rounded-full bg-slate-900 text-white pl-2 pr-3 py-1.5 text-sm font-bold shadow-sm hover:bg-slate-700 transition-colors" data-testid="header-credits-pill">
      <span className="w-5 h-5 rounded-full bg-amber-400 text-slate-900 flex items-center justify-center"><Coins size={12} /></span>
      <span data-testid="header-credits-balance">{Number(w.balance || 0).toLocaleString()}</span>
      {open > 0 && <span className="ml-0.5 w-2 h-2 rounded-full bg-amber-400" data-testid="header-credits-open" />}
    </Link>
  );
}
